module.exports = __webpack_public_path__ + "img/lunbo243.c46f768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo243.png
// module id = YxcV
// module chunks = 0